export default __webpack_public_path__ + "static/media/lost.01401b6a.svg";